import { Link, Outlet, useLocation, Navigate } from 'react-router-dom';
import { HardHat, Cpu, Wrench, LayoutDashboard } from 'lucide-react';
import { ROUTES } from '../components/Navigation/routes';

const TABS = [
  { id: 'aec-tools',    label: 'AEC Tools Explorer',     path: ROUTES.APPS_AEC,    Icon: HardHat  },
  { id: 'custom-tools', label: 'Get Inspired',   path: ROUTES.APPS_CUSTOM, Icon: Cpu      },
  { id: 'consulting',   label: 'Need Help?',     path: ROUTES.CONTACT, to: `${ROUTES.CONTACT}?mode=aec&hero=team`, Icon: Wrench },
];

const HERO_CONTENT = {
  'aec-tools': {
    title: 'Find right tool for you',
    tag: 'AI powered AEC software intelligence, find and get quick insights on off-the-shelf tools.',
  },
  'custom-tools': {
    title: 'Built to meet your business needs.',
    tag: 'Feel free to explore our published solutions to get inspired.',
  },
};

const AppsPage = ({ indexRedirect = false }) => {
  const location = useLocation();

  if (indexRedirect) return <Navigate to={ROUTES.APPS_AEC} replace />;

  const activeId = TABS.find(t => location.pathname.startsWith(t.path))?.id ?? 'aec-tools';
  const hero = HERO_CONTENT[activeId] ?? HERO_CONTENT['aec-tools'];

  return (
    <div className="min-h-screen bg-gray-50">

      {/* ── Hero ── */}
      <section className="relative overflow-hidden bg-white border-b border-gray-100 py-8">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/4 left-1/3 w-80 h-80 bg-purple-500/8 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-pink-500/8 rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 text-xs font-semibold text-purple-500 uppercase tracking-widest mb-3">
            <LayoutDashboard className="w-4 h-4" />
            Apps & Tools
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2 leading-tight">
            {hero.title}
          </h1>
          <p className="text-base text-gray-500 max-w-2xl leading-relaxed">
            {hero.tag}
          </p>
        </div>
      </section>

      {/* ── Sub-nav tabs ── */}
      <div className="sticky top-[69px] z-[15] bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-1 overflow-x-auto py-2.5 scrollbar-hide">
            {TABS.map(({ id, label, path, to, Icon }) => (
              <Link
                key={id}
                to={to ?? path}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all no-underline ${
                  activeId === id
                    ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-sm shadow-purple-200'
                    : 'text-gray-500 hover:text-gray-800 hover:bg-gray-100'
                }`}
              >
                <Icon className="w-3.5 h-3.5 shrink-0" />
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* ── Tab content ── */}
      <Outlet />

    </div>
  );
};

export default AppsPage;
